import { SVGProps, Ref, forwardRef } from 'react';

export const DotsOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M9.5 5C8.375 5 8 5.75 8 6.5S8.375 8 9.5 8 11 7.25 11 6.5 10.625 5 9.5 5" fill="currentColor" />
            <path
                d="M9.5 10.5c-1.125 0-1.5.75-1.5 1.5s.375 1.5 1.5 1.5S11 12.75 11 12s-.375-1.5-1.5-1.5"
                fill="currentColor"
            />
            <path
                d="M8 17.5c0-.75.375-1.5 1.5-1.5s1.5.75 1.5 1.5-.375 1.5-1.5 1.5S8 18.25 8 17.5"
                fill="currentColor"
            />
            <path
                d="M14.5 5c-1.125 0-1.5.75-1.5 1.5S13.375 8 14.5 8 16 7.25 16 6.5 15.625 5 14.5 5"
                fill="currentColor"
            />
            <path d="M13 12c0-.75.375-1.5 1.5-1.5s1.5.75 1.5 1.5-.375 1.5-1.5 1.5S13 12.75 13 12" fill="currentColor" />
            <path
                d="M14.5 16c-1.125 0-1.5.75-1.5 1.5s.375 1.5 1.5 1.5 1.5-.75 1.5-1.5-.375-1.5-1.5-1.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
DotsOutlinedSize24Glyph.displayName = 'DotsOutlinedSize24Glyph';
